import { formatDateString } from '~libs/dayjs';

// For plain calendar dates, NOT timestamps. Services Australia sends `start_date`/`end_date` (and
// the raw `registrationCategories[].startDate`/`endDate`) as `YYYY-MM-DD` — Sequelize `DATEONLY`
// on company_sah_registered_service_types.
//
// Do not use `formatDate` for these. It runs `new Date(value)`, and ECMAScript parses a bare
// `YYYY-MM-DD` as UTC midnight while a date-time string without an offset parses as local. So
// '2024-09-20' renders as "20 Sept 2024, 10:00 am" in AEST (a time that does not exist in the
// data) and as "19 Sept 2024" anywhere behind UTC (the wrong day). `formatDateString` parses
// through dayjs, which is local-time and leaves the calendar date alone.
//
// Same UTC-parse class the `no-restricted-syntax` rule in .eslintrc.js bans on the comparison
// side, and the reason isCurrentlyActiveServiceType compares against dayjs(), not toISOString().
//
// Keeps the '—' placeholder rather than formatDateString's '': these render inline next to a
// separator, e.g. an open-ended registration reads "(20/Sep/2024 - —)" rather than trailing off.
const formatDateOnly = (value: string | null | undefined): string => {
  if (!value) return '—';
  return formatDateString(value);
};

export default formatDateOnly;
